import * as React from "react";
import moment from "moment";
import { useRef } from "react";
import { logObject } from "../../../config/logs";
import { isDisable } from "./EditableCellConfig";
import ContextMenu from "./ContextMenu";
import "./dataMapTable.scss";
import { Tooltip } from "@mui/material";

const MemoisedTextArea = React.memo(
  ({
    role,
    parametersData,
    mapping,
    mappingIndex,
    rowRejectionData,
    parameterIndex,
    value,
    onChange,
    onBlur,
    isDataRejectedByProcessor,
    reProcess,
    isDataRejectedByInvestigatorValidator,
    reValidateInvestigatorValidator,
    onClickMapping,
    onClickCellToRedirect,
    clearMappings,
    entireBatchRejectedByPro,
    entireBatchRejectedByInvestigatorValidator,
    reProcessEntireBatch,
    showContextMenu,
    updateDataUsingManuallyContextMenu,
    // parameterKey,
    // onClickParameterKeyMapping,
  }) => {
    // We need to keep and update the state of the cell normally

    const textAreaRef = useRef(null);
    // const keyTextAreaRef = useRef(null);

    const [isOpemContextMenu, setIsOpemContextMenu] = React.useState(false);
    const [contextEvent, setContextEvent] = React.useState(null);

    const styleRejectedCell = (
      mapping,
      mappingIndex,
      rowRejectionData,
      parameterIndex
    ) => {
      let backgroundColor = "#FFFF";

      if (role === "preProcessor") {
        // cell not mapping popup

        // Check if one of the inputs has a value while the other doesn't
        // const keyMappingPageNo =
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.pageNo;
        // const valueMappingPageNo =
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo;

        // const keyMappingCoordinatesLength =
        //   (parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.keyCoordinates &&
        //     parametersData[parameterIndex]?.mappings[mappingIndex]
        //       ?.keyCoordinates?.length) ||
        //   0;
        // const valueMappingCoordinatesLength =
        //   (parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinates &&
        //     parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates
        //       ?.length) ||
        //   0;
        // if (
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.forNoPreProMappingDataEntryByPro !== true
        // ) {
        //   if (
        // keyMappingPageNo !== "" &&
        // keyMappingPageNo !== undefined &&
        // keyMappingPageNo !== null &&
        // keyMappingPageNo >= 0 &&
        // valueMappingPageNo === "" ||
        // valueMappingPageNo === undefined ||
        // valueMappingPageNo === null ||
        // (valueMappingPageNo !== "" &&
        //   valueMappingPageNo !== undefined &&
        //   valueMappingPageNo !== null &&
        //   valueMappingPageNo >= 0)
        // &&
        // (
        //   keyMappingPageNo === "" ||
        //   keyMappingPageNo === undefined ||
        //   keyMappingPageNo === null
        // )
        // ) {
        //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
        // } else if (
        // (keyMappingPageNo !== "" &&
        //   keyMappingPageNo !== undefined &&
        //   keyMappingPageNo !== null &&
        //   keyMappingPageNo >= 0 &&
        //   keyMappingCoordinatesLength <= 0) ||
        //   valueMappingPageNo !== "" &&
        //   valueMappingPageNo !== undefined &&
        //   valueMappingPageNo !== null &&
        //   valueMappingPageNo >= 0 &&
        //   valueMappingCoordinatesLength <= 0
        // ) {
        //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
        // }
        // }

        // return { backgroundColor };

        // color when row or cell rej by pro
        if (
          mapping?.processorCellRejection?.isRejected ||
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }

        // dark red color for both rejection in cell and in row
        if (
          mapping?.processorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red color for both rejection in row
        if (
          rowRejectionData &&
          rowRejectionData.length > 0 &&
          rowRejectionData[mappingIndex]?.isRowRejectedByProcessor
        ) {
          backgroundColor = "rgb(253 97 71)";
        }
      }

      if (role === "processor") {
        // for resolved and Pro want to see comment'
        if (
          mapping?.processorCellRejection?.isResolved ||
          parametersData[parameterIndex]?.processorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }
        if (
          mapping?.processorCellRejection?.isResolved &&
          parametersData[parameterIndex]?.processorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }

        // any one rejected in cell or row in both role
        if (
          mapping?.processorCellRejection?.isRejected ||
          mapping?.investigatorValidatiorCellRejection?.isRejected ||
          parametersData[parameterIndex]?.processorRowRejection?.isRejected ||
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }

        // dark red color in cell for both role cell rejection only
        if (
          mapping?.processorCellRejection?.isRejected &&
          mapping?.investigatorValidatiorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red when cell and row rej by processor
        if (
          mapping?.processorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red color for both role rejection in row
        if (
          parametersData[parameterIndex]?.processorRowRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if row rejected by vali and cell rej by pro
        if (
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected &&
          // valiRowRejectionDataInPro[mappingIndex]?.isRowRejectedByValidator &&
          mapping?.processorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if cell rejected by vali and row rej by pro
        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if cell rejected by vali and also row rej by vali
        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }
        // if cell is rej by vali and also row rejected and also cell rej by pro
        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected &&
          mapping?.processorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(249 61 61)";
        }
        //  if cell is rej by vali and also row rejected and also row rej by pro
        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected &&
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 32 32)";
        }
        if (
          mapping?.processorCellRejection?.isRejected &&
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected &&
          parametersData[parameterIndex]?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(235 44 109)";
        }
      }
      if (role === "investigatorValidatior") {
        // for resolved and vali want to see comment'
        if (
          mapping?.investigatorValidatiorCellRejection?.isResolved ||
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }
        if (
          mapping?.investigatorValidatiorCellRejection?.isResolved &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }

        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected ||
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }
        if (
          mapping?.investigatorValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]?.investigatorValidatiorRowRejection
            ?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        if (
          parametersData[parameterIndex]?.rowValidationByInvestigatorValidator
            ?.isInvestigatorValidated
        ) {
          backgroundColor = "#e5ffdb";
        }
      } else if (role === "investigatorMappingValidatior") {
        // for resolved and vali want to see comment'
        if (
          mapping?.investigatorMappingValidatiorCellRejection?.isResolved ||
          parametersData[parameterIndex]
            ?.investigatorMappingValidatiorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }
        if (
          mapping?.investigatorMappingValidatiorCellRejection?.isResolved &&
          parametersData[parameterIndex]
            ?.investigatorMappingValidatiorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }

        if (
          mapping?.investigatorMappingValidatiorCellRejection?.isRejected ||
          parametersData[parameterIndex]
            ?.investigatorMappingValidatiorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }
        if (
          mapping?.investigatorMappingValidatiorCellRejection?.isRejected &&
          parametersData[parameterIndex]
            ?.investigatorMappingValidatiorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        if (
          parametersData[parameterIndex]?.rowValidationByInvestigatorMappingValidator
            ?.isInvestigatorMappingValidated
        ) {
          backgroundColor = "#e5ffdb";
        }
      }

      // // Check if one of the inputs has a value while the other doesn't
      // const keyMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData?.pageNo;
      // const valueMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo;

      // const keyMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]
      //     ?.keyCoordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]?.keyCoordinates
      //       ?.length) ||
      //   0;
      // const valueMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates
      //       ?.length) ||
      //   0;

      // if (
      //   (keyMappingPageNo !== "" &&
      //     keyMappingPageNo !== undefined &&
      //     keyMappingPageNo !== null &&
      //     keyMappingPageNo >= 0 &&
      //     (valueMappingPageNo === "" ||
      //       valueMappingPageNo === undefined ||
      //       valueMappingPageNo === null)) ||
      //   (valueMappingPageNo !== "" &&
      //     valueMappingPageNo !== undefined &&
      //     valueMappingPageNo !== null &&
      //     valueMappingPageNo >= 0 &&
      //     (keyMappingPageNo === "" ||
      //       keyMappingPageNo === undefined ||
      //       keyMappingPageNo === null))
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // } else if (
      //   (keyMappingPageNo !== "" &&
      //     keyMappingPageNo !== undefined &&
      //     keyMappingPageNo !== null &&
      //     keyMappingPageNo >= 0 &&
      //     keyMappingCoordinatesLength <= 0) ||
      //   (valueMappingPageNo !== "" &&
      //     valueMappingPageNo !== undefined &&
      //     valueMappingPageNo !== null &&
      //     valueMappingPageNo >= 0 &&
      //     valueMappingCoordinatesLength <= 0)
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // }

      return { backgroundColor };
    };

    const disableText = isDisable(
      mapping,
      mappingIndex,
      parameterIndex,
      role,
      isDataRejectedByProcessor,
      entireBatchRejectedByPro,
      parametersData,
      entireBatchRejectedByInvestigatorValidator,
      reProcessEntireBatch,
      reProcess,
      isDataRejectedByInvestigatorValidator,
      reValidateInvestigatorValidator
    )
      ? true
      : false;

    const onCero = (e, type) => {
      if (isDataRejectedByProcessor !== true) {
        if (e.keyCode === 8 || e.keyCode === 46) {
          clearMappings(type);
        }
      }
    };

    const handleCloseMenu = () => {
      setIsOpemContextMenu(false);
    };

    const handleClick = (event) => {
      event.preventDefault();

      setContextEvent(event);
      setIsOpemContextMenu(true);
    };

    const adjustTextareaHeight = () => {
      const textarea = textAreaRef.current;

      if (textarea) {
        textarea.style.height = "auto"; // Reset the height to auto

        const newHeight = textarea.scrollHeight - 3; // Calculate the new height based on content
        // Set the min height (can be any value, here it's an example of 100px)
        const minHeight = 35; // Example min height
        // Set the height to the greater of the scrollHeight or the minHeight
        textarea.style.height = Math.max(newHeight, minHeight) + "px";
      }
    };

    // const adjustKeyTextareaHeight = () => {
    //   const textarea = keyTextAreaRef.current;

    //   textarea.style.height = "auto"; // Reset the height to auto
    //   textarea.style.height = textarea.scrollHeight + "px"; // Set the height based on content
    // };

    // Call the adjustTextareaHeight function when the component mounts
    React.useEffect(() => {
      adjustTextareaHeight();
      // role === "preProcessor" && adjustKeyTextareaHeight();
    }, []);

    // Call the adjustTextareaHeight function whenever the value changes

    React.useEffect(() => {
      adjustTextareaHeight();
    }, [value]);

    // React.useEffect(() => {
    //   role === "preProcessor" && adjustKeyTextareaHeight();
    // }, [parameterKey, role]);

    const isDisableWrapper = (mapping, mappingIndex, parameterIndex) => {
      if (mapping?.isDerivativeField) {
        return true;
      }
      const isDisableFlag = isDisable(
        mapping,
        mappingIndex,
        parameterIndex,
        role,
        isDataRejectedByProcessor,
        entireBatchRejectedByPro,
        parametersData,
        entireBatchRejectedByInvestigatorValidator,
        reProcessEntireBatch,
        reProcess,
        isDataRejectedByInvestigatorValidator,
        reValidateInvestigatorValidator
      );
      return isDisableFlag;
    };

    return (
      <div className="cell-main">
        <div
          className="cell-outer"
          onContextMenu={(e) => {
            if (showContextMenu) {
              handleClick(e);
            }
          }}
          style={{
            ...styleRejectedCell(
              mapping,
              mappingIndex,
              rowRejectionData,
              parameterIndex
            ),
            ...{
              padding: "0px 15px 0px 5px",
            },
            // to heighlight selected  cell for re initiate vlm

            ...(mapping?.reInitiateProVlm && {
              border: "2px solid #2776d2", // Example for "selected for reprocess"
            }),
          }}
        >
          {/* {role === "preProcessor" && (
            <>
               // key mapping, only used to send key mappings to improve ai but all remeanig functionality like disable color and all based on cell level data/mapping/variables 
              <div style={{ flex: 1, height: "50%" }}>
                <textarea
                  onKeyDown={(e) =>
                    role === "preProcessor" && onCero(e, "toResetKeyMapping")
                  }
                  ref={keyTextAreaRef}
                  className={`${
                    role === "preProcessor"
                      ? "my-textarea-min-height"
                      : "my-textarea"
                  } ${
                    disableText
                      ? "disableCell"
                      : role === "validator"
                      ? "disable_opacity"
                      : ""
                  }`}
                  id="outlined-basic"
                  style={{
                    ...(role !== "preProcessor" && { minHeight: "100%" }),
                    width: "100%",
                    resize: "none",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    // },
                  }}
                  value={parameterKey}
                  onBlur={() =>
                    // in pre on blur only storing logs
                    !isDisableWrapper(mapping, mappingIndex, parameterIndex) &&
                    onBlur("parameterKeyMapping")
                  }
                  onClick={(e) =>
                    !isDisableWrapper(mapping, mappingIndex, parameterIndex) &&
                    onClickParameterKeyMapping(e, parameterIndex, mappingIndex)
                  }
                  onInput={(e) => {
                    // Calculate and set the textarea's height based on content
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                  }}
                  disabled={isDisableWrapper(
                    mapping,
                    mappingIndex,
                    parameterIndex
                  )}
                  placeholder={role === "preProcessor" ? "Parameter" : ""}
                  rows={1}
                />
              </div>
              <Divider variant="fullWidth" className="divider-editable" />
            </>
          )} */}
          {/* <div className={role === "preProcessor" ? "h-48" : "h-100"}> */}

          <Tooltip
            placement="top"
            title={
              mapping.reInitiateProVlm &&
              mapping.proVlmTagName &&
              mapping.proVlmPageNo >= 0
                ? `${mapping.proVlmTagName} - ${
                    parseInt(mapping.proVlmPageNo) + 1
                  }`
                : ""
            }
            arrow
          >
            <textarea
              onKeyDown={
                role === "preProcessor"
                  ? (e) => onCero(e, "toResetValueMapping")
                  : undefined
              }
              ref={textAreaRef}
              className={` ${
                // role === "preProcessor" ? "my-textarea-min-height" : "my-textarea"
                "my-textarea"
              } ${
                disableText
                  ? "disableCell"
                  : role === "investigatorValidatior" ||
                    role === "investigatorMappingValidatior"
                  ? "disable_opacity"
                  : ""
              }`}
              id="outlined-basic"
              style={{
                // ...(role !== "preProcessor" && { minHeight: "100%" }),
                minHeight: "100%",
                width: "100%",
                resize: "none",
                overflow: "hidden",
                backgroundColor: "transparent",
              }}
              value={value}
              onChange={(e) => {
                if (
                  role === "processor" &&
                  !isDisableWrapper(mapping, mappingIndex, parameterIndex)
                ) {
                  onChange(e);
                }
              }}
              onBlur={(e) => {
                if (
                  // role === "preProcessor" ||
                  role === "processor" &&
                  !isDisableWrapper(mapping, mappingIndex, parameterIndex)
                ) {
                  // onBlur("valueMapping");
                  onBlur();
                }
              }}
              onClick={(e) => {
                if (role === "preProcessor") {
                  if (
                    !isDisableWrapper(mapping, mappingIndex, parameterIndex)
                  ) {
                    onClickMapping(e, parameterIndex, mappingIndex);
                  }
                } else {
                  onClickCellToRedirect(
                    e,
                    mapping?.tagName,
                    mapping?.pageNo,
                    mapping?.fileNo,
                    parameterIndex,
                    mappingIndex,
                    mapping?.coordinates,
                    isDisableWrapper(mapping, mappingIndex, parameterIndex),
                    mapping?.actual_page_number
                  );
                }
              }}
              // onInput={(e) => {
              //   if (role !== "validator") {
              //     // Calculate and set the textarea's height based on content
              //     e.target.style.height = "auto";
              //     e.target.style.height = e.target.scrollHeight + "px !important";
              //   }
              // }}
              disabled={
                role !== "processor" &&
                isDisableWrapper(mapping, mappingIndex, parameterIndex)
              }
              // placeholder={role === "preProcessor" ? "Value" : ""}
              rows={1}
            />
          </Tooltip>
          {/* </div> */}
          <ContextMenu
            showContextMenu={showContextMenu}
            isOpemContextMenu={isOpemContextMenu}
            handleCloseMenu={handleCloseMenu}
            updateDataUsingManuallyContextMenu={
              updateDataUsingManuallyContextMenu
            }
            parameterIndex={parameterIndex}
            mappingIndex={mappingIndex}
            contextEvent={contextEvent}
          />
        </div>
      </div>
    );
  }
);

const EditableCell = ({
  mapping,
  mappingIndex,
  parameterIndex,
  parametersData,
  setParametersData,
  rowRejectionData,
  role,
  onClickMapping,
  onClickCellToRedirect,
  anyOperationPerformedOnEntirePage,
  reProcess,
  isDataRejectedByProcessor,
  isDataRejectedByInvestigatorValidator,
  reValidateInvestigatorValidator,
  clearMappings,
  entireBatchRejectedByPro,
  entireBatchRejectedByInvestigatorValidator,
  reProcessEntireBatch,
  showContextMenu,
  updateDataUsingManuallyContextMenu,
  selectedFilesDataForProUpdate,
  setLogs,
  selectedFile,
  coordinatesData,
  updateLastSelectedPageForProUpdateMapping,
  // onClickParameterKeyMapping,
}) => {
  const textValue = (mapping) => {
    let value = "";

    if (role === "preProcessor" || role === "investigatorMappingValidatior") {
      value =
        mapping?.lockedPreTagName && mapping.lockedPrePageNo >= 0
          ? `${mapping?.lockedPreTagName} - ${
              parseInt(mapping.lockedPrePageNo) + 1
            }`
          : // :
            // mapping?.tagName && mapping.pageNo >= 0
            // ? `${mapping?.tagName} - ${parseInt(mapping.pageNo) + 1}`
            "";
    } else {
      value = mapping?.value;
    }
    return value;
  };

  // const keyTextValue = (keyMapping) => {
  //   let value = "";

  //   if (role === "preProcessor") {
  //     value =
  //       keyMapping?.tagName && keyMapping.pageNo >= 0
  //         ? `${keyMapping?.tagName} - ${parseInt(keyMapping.pageNo) + 1}`
  //         : "";
  //   }
  //   return value;
  // };

  const initialValue = textValue(mapping);
  // const initialKeyValue = keyTextValue(mapping?.keyData);

  const [value, setValue] = React.useState(initialValue);
  // const [parameterKey, setParameterKey] = React.useState(initialKeyValue);
  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // React.useEffect(() => {
  //   setParameterKey(initialKeyValue);
  // }, [initialKeyValue]);

  const onChange = (e) => {
    let value = e.target.value;
    const regex = /\n/g;
    value = value.replace(regex, "");
    setValue(value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = (string) => {
    // called only in pro role in vali cell is disabled so its not calling
    if (role === "processor") {
      let valueBeforeChange = "";

      if (parametersData[parameterIndex].mappings[mappingIndex]) {
        valueBeforeChange =
          parametersData[parameterIndex]?.mappings[mappingIndex]?.value;

        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          value: value,
          processor: localStorage?.userName,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
        };

        if (
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName &&
          parametersData[parameterIndex].mappings[mappingIndex]?.fileNo &&
          parametersData[parameterIndex].mappings[mappingIndex]?.pageNo
        ) {
          updateLastSelectedPageForProUpdateMapping({
            tagName:
              parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
            fileNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
            pageNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          });
        }
      }

      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.value !== ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        };

        // for insertion of logs
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            extractionType: "template",
            category: "dataEntry",
            action:
              // string === "valueMapping"
              //   ?
              "Mapping Added by Processor for Unmapped Data",
            // : "Add Parameter Key Mapping",
            parameter: parametersData[parameterIndex]?.parameter,
            templateTagName: parametersData[parameterIndex]?.tagName,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinates,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.coordinates,
            coordinatesValues:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinatesValues,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.coordinatesValues,

            tagName:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.tagName,

            pageNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.pageNo,

            fileNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.fileNo,

            rowColIndex: [
              parseInt(parameterIndex) + 1,
              parseInt(mappingIndex) + 1,
            ],
            mbrName: selectedFile?.originalFileName || "",
            document:
              coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
                ?.imageUrl,
          }),
        ]);
      }

      setParametersData([...parametersData]);
      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
      if (valueBeforeChange !== value) {
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            extractionType: "template",
            category: "dataEntry",
            action: "Data Entered",
            parameter: parametersData[parameterIndex]?.parameter,
            templateTagName: parametersData[parameterIndex]?.tagName,
            value: value,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates:
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinates,
            coordinatesValues:
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinatesValues,
            tagName:
              parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
            pageNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
            fileNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
            rowColIndex: [
              parseInt(parameterIndex) + 1,
              parseInt(mappingIndex) + 1,
            ],
            mbrName: selectedFile?.originalFileName,
            document:
              coordinatesData[
                parseInt(
                  parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo
                )
              ]?.pages[
                parseInt(
                  parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
                )
              ]?.imageUrl,
          }),
        ]);
      }
    }

    // if (role === "preProcessor") {
    //   if (
    //     selectedFile?.tagName !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName ||
    //     selectedFile?.fileNo !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo ||
    //     selectedFile?.pageNo !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
    //   ) {
    //     // for insertion of logs
    //     setLogs((prevLogs) => [
    //       ...prevLogs,
    //       logObject({
    //         extractionType: "template",
    //         category: "mapping",
    //         action:
    //           // string === "valueMapping"
    //           //   ?
    //           "Value Mapping Added",
    //         // : "Key Mapping Added",
    //         parameter: parametersData[parameterIndex]?.parameter,
    //         dataType: parametersData[parameterIndex]?.dataType,
    //         rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //         rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //         coordinates:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]
    //             ?.coordinates,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.coordinates,
    //         coordinatesValues:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]
    //             ?.coordinatesValues,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.coordinatesValues,

    //         tagName:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.tagName,

    //         pageNo:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.pageNo,

    //         fileNo:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.fileNo,

    //         rowColIndex: [
    //           parseInt(parameterIndex) + 1,
    //           parseInt(mappingIndex) + 1,
    //         ],
    //         mbrName: selectedFile?.originalFileName || "",
    //         document:
    //           coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
    //             ?.imageUrl,
    //       }),
    //     ]);
    //   }
    // }
  };

  return (
    <MemoisedTextArea
      role={role}
      parametersData={parametersData}
      mapping={mapping}
      mappingIndex={mappingIndex}
      rowRejectionData={rowRejectionData}
      parameterIndex={parameterIndex}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      isDataRejectedByProcessor={isDataRejectedByProcessor}
      reProcess={reProcess}
      isDataRejectedByInvestigatorValidator={
        isDataRejectedByInvestigatorValidator
      }
      reValidateInvestigatorValidator={reValidateInvestigatorValidator}
      onClickMapping={onClickMapping}
      onClickCellToRedirect={onClickCellToRedirect}
      clearMappings={clearMappings}
      entireBatchRejectedByPro={entireBatchRejectedByPro}
      entireBatchRejectedByInvestigatorValidator={
        entireBatchRejectedByInvestigatorValidator
      }
      reProcessEntireBatch={reProcessEntireBatch}
      showContextMenu={showContextMenu}
      updateDataUsingManuallyContextMenu={updateDataUsingManuallyContextMenu}
      // parameterKey={parameterKey}
      // onClickParameterKeyMapping={onClickParameterKeyMapping}
    />
  );
};

export default EditableCell;
